<script setup lang="ts">
const reload = () => {
   window.location.reload();
};
</script>

<template>
   <div class="page-load-failed">
      <div class="load-failed-card text-center">
         <div class="load-failed-icon">
            <i class="fa fa-wifi" aria-hidden="true"></i>
         </div>
         <h1 class="load-failed-title">Offline</h1>
         <p class="load-failed-subtitle">Couldn't Load This Page</p>
         <p class="load-failed-message">
            This page's content couldn't be reached — the connection may be down or the server unavailable.
            <br />
            Check your connection and try again.
         </p>
         <div class="load-failed-actions">
            <a
               href="#"
               class="btn btn-primary btn-lg"
               @click.prevent="reload"
            >
               Retry
            </a>
            <a href="/" class="btn btn-outline-secondary btn-lg">
               Go to Home
            </a>
         </div>
      </div>
   </div>
</template>

<style lang="scss" scoped>
.page-load-failed {
   min-height: 100vh;
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 2rem 1rem;
   background: #f7f9fa;
}

.load-failed-card {
   width: 100%;
   max-width: 480px;
   padding: 3rem 2.5rem;
   background: #fff;
   border-radius: 12px;
   box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.load-failed-icon {
   width: 72px;
   height: 72px;
   margin: 0 auto 1.5rem;
   display: flex;
   align-items: center;
   justify-content: center;
   background: rgba(30, 120, 76, 0.1);
   border-radius: 50%;

   i {
      font-size: 32px;
      color: #1e784c;
   }
}

.load-failed-title {
   margin-bottom: 0.25rem;
   font-size: 2rem;
   font-weight: 700;
   color: #1e784c;
}

.load-failed-subtitle {
   margin-bottom: 1rem;
   font-size: 1.25rem;
   font-weight: 600;
   color: #333;
}

.load-failed-message {
   margin-bottom: 2rem;
   color: #777;
   line-height: 1.5;
}

.load-failed-actions {
   display: flex;
   justify-content: center;
   gap: 0.75rem;

   .btn {
      min-width: 130px;
   }
}
</style>
